
<template>
  <div class="what-we-do-area pt-100 pb-75">
    <div class="container">
      <div class="section-title">
        <span class="sub-title">O Que Fazemos</span>
        <h2>Nosso trabalho é entregue pela melhor equipe do mundo</h2>
      </div>
      <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-6" data-aos="fade-up" data-aos-duration="1200">
          <div class="single-what-we-do-box">
            <div class="icon">
              <img src="../../assets/images/icon/icon5.png" alt="icon">
            </div>
            <h3>Infraestrutura Incrível</h3>
            <p>Construímos a base tecnológica ideal para seu negócio crescer. Nosso trabalho é entregue pela melhor equipe do mundo.</p>
<!--            <router-link to="/services-details" class="link-btn">Saiba Mais <i class="ph-caret-right"></i></router-link>-->
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="100">
          <div class="single-what-we-do-box">
            <div class="icon">
              <img src="../../assets/images/icon/icon6.png" alt="icon">
            </div>
            <h3>Lembretes de Prazo</h3>
            <p>Sistemas inteligentes que mantêm sua equipe sempre no prazo. Nosso trabalho é entregue pela melhor equipe do mundo.</p>
<!--            <router-link to="/services-details" class="link-btn">Saiba Mais <i class="ph-caret-right"></i></router-link>-->
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6" data-aos="fade-up" data-aos-duration="1200">
          <div class="single-what-we-do-box">
            <div class="icon">
              <img src="../../assets/images/icon/icon7.png" alt="icon">
            </div>
            <h3>Recuperação de Informações</h3>
            <p>Ferramentas avançadas para encontrar e organizar dados rapidamente. Nosso trabalho é entregue pela melhor equipe do mundo.</p>
<!--            <router-link to="/services-details" class="link-btn">Saiba Mais <i class="ph-caret-right"></i></router-link>-->
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="100">
          <div class="single-what-we-do-box">
            <div class="icon">
              <img src="../../assets/images/icon/icon8.png" alt="icon">
            </div>
            <h3>Dashboard Simples</h3>
            <p>Painéis intuitivos que facilitam a gestão do seu negócio. Nosso trabalho é entregue pela melhor equipe do mundo.</p>
<!--            <router-link to="/services-details" class="link-btn">Saiba Mais <i class="ph-caret-right"></i></router-link>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WhatWeDo'
}
</script>